import { render, staticRenderFns } from "./LandingPagePreview.vue?vue&type=template&id=5930a406&scoped=true&"
import script from "./LandingPagePreview.vue?vue&type=script&lang=js&"
export * from "./LandingPagePreview.vue?vue&type=script&lang=js&"
import style0 from "./LandingPagePreview.vue?vue&type=style&index=0&id=5930a406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930a406",
  null
  
)

export default component.exports